export default __webpack_public_path__ + "static/media/Milestone 1L.f9af0906.svg";